import { View, Text, ProgressCircle } from '@/components'
import { parseScoreProgress } from '../../utils'

export const Score = ({ img = null, score, name, color }) => {
  return (
    <View variants={['gap:2', 'alignCenter']}>
      <ProgressCircle progress={score} image={img} variants={['small', 'noLabel']} color={color} />
      <View variants={['column']}>
        <Text variants={['h5', 'color:neutral5']}>{parseScoreProgress(score)}</Text>
        <Text variants={['p2', 'color:neutral9']}>{name}</Text>
      </View>
    </View>
  )
}
